"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupFooter = void 0;
var Utilities_1 = require("../../Utilities");
var GroupFooter_styles_1 = require("./GroupFooter.styles");
var GroupFooter_base_1 = require("./GroupFooter.base");
exports.GroupFooter = (0, Utilities_1.styled)(GroupFooter_base_1.GroupFooterBase, GroupFooter_styles_1.getStyles, undefined, {
    scope: 'GroupFooter',
});
//# sourceMappingURL=GroupFooter.js.map